import React from "react";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import SpaceDashboardOutlinedIcon from "@mui/icons-material/SpaceDashboardOutlined";
import PeopleOutlinedIcon from "@mui/icons-material/PeopleOutlined";
import AdminPanelSettingsOutlinedIcon from "@mui/icons-material/AdminPanelSettingsOutlined";
import HubOutlinedIcon from "@mui/icons-material/HubOutlined";
import HandshakeOutlinedIcon from "@mui/icons-material/HandshakeOutlined";
import CategoryOutlinedIcon from "@mui/icons-material/CategoryOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import VpnKeyOutlinedIcon from "@mui/icons-material/VpnKeyOutlined";
import CreditCardOutlinedIcon from "@mui/icons-material/CreditCardOutlined";
import SpeakerOutlinedIcon from "@mui/icons-material/SpeakerOutlined";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import PercentOutlinedIcon from "@mui/icons-material/PercentOutlined";
import PersonSearchOutlinedIcon from "@mui/icons-material/PersonSearchOutlined";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import ConfirmationNumberOutlinedIcon from "@mui/icons-material/ConfirmationNumberOutlined";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import EngineeringOutlinedIcon from "@mui/icons-material/EngineeringOutlined";
import HistoryOutlinedIcon from "@mui/icons-material/HistoryOutlined";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import AccountBalanceOutlinedIcon from "@mui/icons-material/AccountBalanceOutlined";
import CurrencyExchangeOutlinedIcon from "@mui/icons-material/CurrencyExchangeOutlined";
import SecurityOutlinedIcon from "@mui/icons-material/SecurityOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import ListAltOutlinedIcon from "@mui/icons-material/ListAltOutlined";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import { PERMISSIONS } from "../../../utils/Permissions";
import InventoryIcon from "@mui/icons-material/Inventory";

/** V2 sidebar only: MUI outlined icons, black (V1 uses PNGs in constants.js). */
const NAV_ICON_SX = { fontSize: 22, color: "#000000" };
// 0: "merchant profile"
// 1: "dashboard"
// 2: "individual merchant"
// 3: "business merchant"
// 4: "search-permission"
// 5: "all-permission"

export const navDataV2 = [
  {
    icon: <HomeOutlinedIcon sx={NAV_ICON_SX} />,
    link: "/welcome",
    title: "Home",
    id: "HOME",
    role: ["ROLE_MERCHANT_DISTRIBUTOR", "ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
    alwaysShow: true,
    expanded: false,
    active: true,
  },
  {
    icon: <SpaceDashboardOutlinedIcon sx={NAV_ICON_SX} />,
    link: "/dashboard",
    title: "Overview",
    id: "DASHBOARD",
    role: ["ROLE_MERCHANT_DISTRIBUTOR", "ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
    permissions: [PERMISSIONS.OVERVIEW],
    expanded: false,
    active: true,
  },
  {
    icon: <PeopleOutlinedIcon sx={NAV_ICON_SX} />,
    link: "/merchant-profile",
    title: "User",
    id: "MERCHANT_PROFILE",
    role: ["ROLE_MERCHANT_DISTRIBUTOR", "ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
    permissions: [
      PERMISSIONS.MERCHANT_INDIVIDUAL_MERCHANT,
      PERMISSIONS.MERCHANT_BUSINESS_MERCHANT,
      PERMISSIONS.MERCHANT_MIN_KYC_USER,
      PERMISSIONS.MERCHANT_NCMC_USER,
      PERMISSIONS.MERCHANT_FOS_USER,
    ],
    expanded: false,
    active: true,
    subNav: [
      {
        icon: "",
        link: "/merchant/individual/list",
        title: "Individual User",
        role: ["ROLE_MERCHANT_DISTRIBUTOR", "ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.MERCHANT_INDIVIDUAL_MERCHANT],
      },
      {
        icon: "",
        link: "/merchant/business/list",
        title: "Business User",
        role: ["ROLE_MERCHANT_DISTRIBUTOR", "ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.MERCHANT_BUSINESS_MERCHANT],
      },
      {
        icon: "",
        link: "/merchant/basic_user/list",
        title: "Min Kyc User",
        role: ["ROLE_MERCHANT_DISTRIBUTOR", "ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.MERCHANT_MIN_KYC_USER],
      },
      {
        icon: "",
        link: "/merchant/ncmc_user/list",
        title: "NCMC User",
        role: ["ROLE_MERCHANT_DISTRIBUTOR", "ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.MERCHANT_NCMC_USER],
      },
      {
        icon: "",
        link: "/merchant/fos_user/list",
        title: "FOS User",
        role: ["ROLE_MERCHANT_DISTRIBUTOR", "ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.MERCHANT_FOS_USER],
      },
    ],
  },
  {
    icon: <AdminPanelSettingsOutlinedIcon sx={NAV_ICON_SX} />,
    link: "/manage-admin",
    title: "Manage Admin",
    id: "CREATE_USER",
    role: ["ROLE_MERCHANT_ADMIN"],
    permissions: [PERMISSIONS.ADMIN_ADD, PERMISSIONS.ADMIN_VIEW],
    expanded: false,
    active: true,
    subNav: [
      {
        icon: "",
        link: "/admin-register",
        title: "Add Admin",
        role: ["ROLE_MERCHANT_ADMIN"],
        permissions: [PERMISSIONS.ADMIN_ADD],
      },
      {
        icon: "",
        link: "/admin-list",
        title: "View Admin",
        role: ["ROLE_MERCHANT_ADMIN"],
        permissions: [PERMISSIONS.ADMIN_VIEW],
      },
    ],
  },
  {
    icon: <HubOutlinedIcon sx={NAV_ICON_SX} />,
    link: "/manage-distributor",
    title: "Manage Distributor",
    id: "CREATE_USER",
    role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
    permissions: [PERMISSIONS.MANAGE_DISTRIBUTOR_ADD, PERMISSIONS.MANAGE_DISTRIBUTOR_VIEW],
    expanded: false,
    active: true,
    subNav: [
      {
        icon: "",
        link: "/distributor-register",
        title: "Add Distributor",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.MANAGE_DISTRIBUTOR_ADD],
      },
      {
        icon: "",
        link: "/distributor-list",
        title: "View Distributor",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.MANAGE_DISTRIBUTOR_VIEW],
      },
    ],
  },

  {
    icon: <HandshakeOutlinedIcon sx={NAV_ICON_SX} />,
    link: "/partner",
    title: "Partner",
    id: "PARTNER",
    role: ["ROLE_MERCHANT_DISTRIBUTOR", "ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
    permissions: [PERMISSIONS.PARTNER_SOCIETY_PARTNER],
    expanded: false,
    active: true,
    subNav: [
      {
        icon: "",
        link: "/society-partner",
        title: "Society Partner",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.PARTNER_SOCIETY_PARTNER],
      },
      {
        icon: "",
        link: "/program-manager",
        title: " Add Program Manager",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.PARTNER_SOCIETY_PARTNER],
      },
      {
        icon: "",
        link: "/tid-whitelisting",
        title: " TID Whitelisting",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.TID_WHITELISTING],
      },
    ],
  },
   {
    icon: <DescriptionOutlinedIcon sx={NAV_ICON_SX} />,
    link: "/form-60",
    title: "Form 60",
    id: "PARTNER",
    role: ["ROLE_MERCHANT_DISTRIBUTOR", "ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
    permissions: [PERMISSIONS.FORM_60],
    expanded: false,
    active: true,
  },
  {
    icon: <AccountBalanceIcon sx={NAV_ICON_SX} />,
    link: "/autopay",
    title: "Manage AutoPay",
    id: "AutoPay",
    role: ["ROLE_MERCHANT_DISTRIBUTOR", "ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
    permissions: [PERMISSIONS.MANAGE_AUTOPAY],
    expanded: false,
    active: true,
    subNav: [
      {
        icon: "",
        link: "/view-autopay-list",
        title: "AutoPay",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.MANAGE_AUTOPAY],
      },
      {
        icon: "",
        link: "/revoke-autopay-list",
        title: "Revoke AutoPay",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.MANAGE_AUTOPAY],
      },
    ],
  },

  {
    icon: <CategoryOutlinedIcon sx={NAV_ICON_SX} />,
    link: "/mcc",
    title: "Manage MCC",
    id: "MCC",
    role: ["ROLE_MERCHANT_DISTRIBUTOR", "ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
    permissions: [PERMISSIONS.MERCHANT_BUSINESS_MERCHANT],
    expanded: false,
    active: true,
    subNav: [
      {
        icon: "",
        link: "/new-mcc",
        title: "Add New MCC",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.MERCHANT_BUSINESS_MERCHANT],
      },
      {
        icon: "",
        link: "/view-mcc-list",
        title: "View MCC Lst",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.MERCHANT_BUSINESS_MERCHANT],
      },
    ],
  },

  {
    icon: <SettingsOutlinedIcon sx={NAV_ICON_SX} />,
    link: "/payment-settings",
    title: "Payment Settings",
    id: "ADD_CONFIG",
    role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
    permissions: [
      PERMISSIONS.PAYMENT_SETTING_ADD_NEW,
      PERMISSIONS.PAYMENT_SETTING_LIST,
      PERMISSIONS.PAYMENT_SETTING_DEFAULT,
      PERMISSIONS.PAYMENT_SETTING_MCC_CONFIGURATION,
      PERMISSIONS.PAYMENT_SETTING_CASHBACK_CONFIGURATION
    ],
    expanded: false,
    active: true,
    subNav: [
      {
        icon: "",
        link: "/payment-settings/add",
        title: "Add New",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.PAYMENT_SETTING_ADD_NEW],
      },
      {
        icon: "",
        link: "/payment-settings/list",
        title: "List",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.PAYMENT_SETTING_LIST],
      },
      {
        icon: "",
        link: "/payment-settings/default",
        title: "Default",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.PAYMENT_SETTING_DEFAULT],
      },
      {
        icon: "",
        link: "/payment-settings/mcc",
        title: "MCC Configuration",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.PAYMENT_SETTING_MCC_CONFIGURATION],
      },
     {
        icon: "",
        link: "/payment-settings/cashback",
        title: "Cashback Configuration",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.PAYMENT_SETTING_CASHBACK_CONFIGURATION],
      },
    ],
  },
  {
    icon: <VpnKeyOutlinedIcon sx={NAV_ICON_SX} />,
    link: "/manage-permission",
    title: "Manage Permission",
    id: "UPDATE_PERMISSION",
    role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
    permissions: [PERMISSIONS.MANAGE_PERMISSION],
    active: true,
    expanded: false,
  },
  {
    icon: <CreditCardOutlinedIcon sx={NAV_ICON_SX} />,
    link: "/manage-card",
    title: "Manage Card",
    id: "PREPAID_CARD_VIEW",
    expanded: false,
    role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
    permissions: [
      PERMISSIONS.MANAGE_CARD_ASSIGN_CARD,
      PERMISSIONS.MANAGE_CARD_PHYSICAL_CARD,
      PERMISSIONS.MANAGE_CARD_VIRTUAL_CARD,
      PERMISSIONS.MANAGE_CARD_ORDER_LIST,
      PERMISSIONS.INVENTORY_FILE_LIST,
    ],
    active: true,
    subNav: [
      {
        icon: "",
        link: "/manage-card/list",
        title: "Assign Cards",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.MANAGE_CARD_ASSIGN_CARD],
      },
      {
        icon: "",
        link: "/manage-card/physical-card",
        title: "Manage Physical Card",
        role: ["ROLE_MERCHANT_ADMIN"],
        permissions: [PERMISSIONS.MANAGE_CARD_PHYSICAL_CARD],
      },
      {
        icon: "",
        link: "/manage-card/virtual-card",
        title: "Manage Virtual Card",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.MANAGE_CARD_VIRTUAL_CARD],
      },
      {
        icon: "",
        link: "/manage-card/orders",
        title: "Manage Order List",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.MANAGE_CARD_ORDER_LIST],
      },
       {
        icon: "",
        link: "/manage-card/inventory-listing",
        title: "Physical Card Inventory List",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.INVENTORY_FILE_LIST],
      },
    ],
  },
  {
    icon: <SpeakerOutlinedIcon sx={NAV_ICON_SX} />,
    link: "/manage-soundbox/orders",
    title: "Manage SoundBox Order",
    id: "SOUNDBOX_ORDER",
    role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
    permissions: [PERMISSIONS.MANAGE_SOUNDBOX_ORDER],
    active: true,
    expanded: false,
  },
  {
    icon: <ReceiptLongOutlinedIcon sx={NAV_ICON_SX} />,
    link: "/transactions",
    title: "Transactions",
    id: "TRANSACTION_LISTING",
    role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
    permissions: [PERMISSIONS.TRANSACTION_PAYMENT, PERMISSIONS.TRANSACTION_SETTLEMENT],
    expanded: false,
    active: true,
  },
  {
    icon: <PercentOutlinedIcon sx={NAV_ICON_SX} />,
    link: "/transaction-charges",
    title: "Transaction Charges",
    id: "TRANSACTION_CHARGES",
    role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
    permissions: [PERMISSIONS.TRANSACTION_CHARGES],
    expanded: false,
    active: true,
  },
  {
    icon: <PersonSearchOutlinedIcon sx={NAV_ICON_SX} />,
    link: "/",
    title: "View User List",
    id: "DASHBOARD",
    role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
    permissions: [PERMISSIONS.VIEW_USER_LIST],
    expanded: false,
    active: false,
  },

  {
    icon: <AssessmentOutlinedIcon sx={NAV_ICON_SX} />,
    link: "/reports",
    title: "Manage Reports",
    id: "TNC",
    role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
    permissions: [
      PERMISSIONS.MANAGE_REPORT,
      PERMISSIONS.MANAGE_REPORT_BY_TRANSACTIONS,
      PERMISSIONS.MANAGE_DAILY_REPORT,
      PERMISSIONS.MANAGE_HOLD_BALANCE_REPORT,
      PERMISSIONS.MANAGE_MAIN_REPORT,
      PERMISSIONS.MANAGE_APPROVE_EMAIL_REPORTS,
      PERMISSIONS.MANAGE_ORG_SETTLEMENT_REPORTS,
      PERMISSIONS.MANAGE_ORG_TRANSACTION_REPORTS,
      PERMISSIONS.MANAGE_UPI_REPORTS,
    ],
    expanded: false,

    active: true,
    subNav: [
      {
        icon: "",
        link: "/reports",
        title: "Reports",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.MANAGE_REPORT],
      },
      {
        icon: "",
        link: "/reports-by-transaction",
        title: "Reports By Transaction",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.MANAGE_REPORT_BY_TRANSACTIONS],
      },
      {
        icon: "",
        link: "/daily-reports",
        title: "Daily Reports",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.MANAGE_DAILY_REPORT],
      },
      {
        icon: "",
        link: "/hold_balance_reports",
        title: "Hold Balance Reports",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.MANAGE_HOLD_BALANCE_REPORT],
      },
      {
        icon: "",
        link: "/org_hold_balance_reports",
        title: "Org Hold Balance Reports",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.MANAGE_HOLD_BALANCE_REPORT],
      },
      {
        icon: "",
        link: "/main_reports",
        title: "Main Report",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.MANAGE_MAIN_REPORT],
      },
      {
        icon: "",
        link: "/email_reports",
        title: "Approve Email Reports",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.MANAGE_APPROVE_EMAIL_REPORTS],
      },
      {
        icon: "",
        link: "/org_settelement_reports",
        title: "ORG Settlement Reports",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.MANAGE_ORG_SETTLEMENT_REPORTS],
      },
      {
        icon: "",
        link: "/org_transaction_reports",
        title: "ORG Transaction Reports",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.MANAGE_ORG_TRANSACTION_REPORTS],
      },
      {
        icon: "",
        link: "/offline_report",
        title: "Offline Transaction Report",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.MANAGE_OFFLINE_TRANSACTION_REPORT],
      },
      {
        icon: "",
        link: "/upi_reports",
        title: "Upi Reports",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.MANAGE_UPI_REPORTS],
      },
      {
        icon: "",
        link: "/settlement_reports",
        title: "Settlement Report",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.MANAGE_REPORT],
      },
      {
        icon: "",
        link: "/transaction_reports",
        title: "Transaction Report",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.MANAGE_REPORT],
      },
      // {
      //   icon: "",
      //   link: "//transaction_reports",
      //   title: "Transaction Report",
      //   role: ["ROLE_MERCHANT_ADMIN","ROLE_MERCHANT_SUBADMIN"],
      // },
      // {
      //   icon: "",
      //   link: "//settlement_reports",
      //   title: "Settlement Report",
      //   role: ["ROLE_MERCHANT_ADMIN","ROLE_MERCHANT_SUBADMIN"],
      // },
      // {
      //   icon: "",
      //   link: "/escrow-transactions",
      //   title: "Live Escrow Statement",
      // },
    ],
  },
  {
    icon: <DescriptionOutlinedIcon sx={NAV_ICON_SX} />,
    link: "/",
    title: "Generate Report",
    id: "DASHBOARD",
    role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
    permissions: [PERMISSIONS.GENERATE_REPORT],
    expanded: false,
    active: false,
  },
  // {
  //   icon: <NotificationsOutlinedIcon sx={NAV_ICON_SX} />,
  //   link: "/send-notification",
  //   title: "Send Notifications",
  //   id: "TNC",
  //   role: ["ROLE_MERCHANT_ADMIN","ROLE_MERCHANT_SUBADMIN"],
  //   active: true,
  //   expanded: false,
  // },
  {
    icon: <NotificationsOutlinedIcon sx={NAV_ICON_SX} />,
    link: "/manage-notification",
    title: "Manage Notification",
    id: "TNC",
    role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
    permissions: [PERMISSIONS.SEND_NOTIFICATION, PERMISSIONS.LIST_NOTIFICATION],
    expanded: false,
    active: true,
    subNav: [
      {
        icon: "",
        link: "/list-notification",
        title: "Notification List",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.LIST_NOTIFICATION],
      },
      {
        icon: "",
        link: "/send-notification",
        title: "Send Notifications",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.SEND_NOTIFICATION],
      },
      {
        icon: "",
        link: "/banner/list",
        title: "Banner",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.LIST_NOTIFICATION],
      },
      {
        icon: "",
        link: "/maintenance/list",
        title: "Schedule Maintenance",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.LIST_NOTIFICATION],
      },

    ],
  },
  {
    icon: <ConfirmationNumberOutlinedIcon sx={NAV_ICON_SX} />,
    link: "/manage-tickets",
    title: "Ticket Management",
    id: "ADMIN_TICKET_CREATE",
    role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
    permissions: [PERMISSIONS.TICKET_MANAGEMENT],
    expanded: false,
    active: true,
  },
  {
    icon: <HelpOutlineIcon sx={NAV_ICON_SX} />,
    link: "/support",
    title: "Help & Support",
    id: "TNC",
    role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
    permissions: [PERMISSIONS.HELP_SUPPORT],
    expanded: false,
    active: true,
  },
  {
    icon: <EngineeringOutlinedIcon sx={NAV_ICON_SX} />,
    link: "/manage-operators",
    title: "Manage Operator",
    id: "CREATE_OPERATOR",
    role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
    permissions: [PERMISSIONS.MANAGE_OPERATOR],
    expanded: false,
    active: true,
  },
  // {
  //   icon: <QrCode2Outlined sx={NAV_ICON_SX} />,
  //   link: "/qr-generate",
  //   title: "QR Generate",
  //   id: "TNC",
  //   expanded: false,
  //   active: true,
  // }, // enable: import QrCode2Outlined from "@mui/icons-material/QrCode2Outlined"
  // {
  //   icon: <CollectionsOutlined sx={NAV_ICON_SX} />,
  //   link: "/manage-banner",
  //   title: "Manage Banner",
  //   id: "TNC",
  //   expanded: false,
  //   active: true,
  // }, // enable: import CollectionsOutlined from "@mui/icons-material/CollectionsOutlined"
  {
    icon: <HistoryOutlinedIcon sx={NAV_ICON_SX} />,
    link: "/login-history",
    title: "Login History",
    id: "TNC",
    role: ["ROLE_MERCHANT_ADMIN", "ROLE_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
    permissions: [PERMISSIONS.LOGIN_HISTORY],
    expanded: false,
    active: true,
  },
  {
    icon: <LockOutlinedIcon sx={NAV_ICON_SX} />,
    link: "/change-password",
    title: "Change Password",
    id: "TNC",
    role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
    permissions: [PERMISSIONS.CHANGE_PASSWORD],
    expanded: false,
    active: true,
  },
  {
    icon: <AccountBalanceOutlinedIcon sx={NAV_ICON_SX} />,
    link: "/reconcile-collect",
    title: "Reconcile Collect",
    id: "TNC",
    permissions: [PERMISSIONS.RECONCILE_APPROVAL_USER_LIST, PERMISSIONS.RECONCILE_REQUEST_LIST],
    expanded: false,
    active: true,
    subNav: [
      {
        icon: "",
        link: "/reconcile/approval-user-list",
        title: "Approval User List",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.RECONCILE_APPROVAL_USER_LIST],
      },
      {
        icon: "",
        link: "/reconcile/request-list",
        title: "Request List",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.RECONCILE_REQUEST_LIST],
      },
    ],
  },
  {
    icon: <CurrencyExchangeOutlinedIcon sx={NAV_ICON_SX} />,
    link: "/payback",
    title: "Manage Payback",
    id: "TNC",
    role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
    permissions: [
      PERMISSIONS.MANAGE_PAYBACK,
      PERMISSIONS.MANAGE_PAYBACK_APPROVAL_USER_LIST,
      PERMISSIONS.MANAGE_PAYBACK_REQUEST_LIST,
    ],
    expanded: false,

    active: true,
    subNav: [
      {
        icon: "",
        link: "/payback",
        title: "Payback",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.MANAGE_PAYBACK],
      },
      {
        icon: "",
        link: "/payback/approval-user-list",
        title: "Approval User List",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.MANAGE_PAYBACK_APPROVAL_USER_LIST],
      },
      {
        icon: "",
        link: "/payback/request-list",
        title: "Request List",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.MANAGE_PAYBACK_REQUEST_LIST],
      },
    ],
  },
  {
    icon: <SecurityOutlinedIcon sx={NAV_ICON_SX} />,
    link: "/permission-management",
    title: "Access Management",
    id: "AM",
    role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
    permissions: [PERMISSIONS.PERMISSION_MANAGEMENT, PERMISSIONS.ROLE_MANAGEMENT],
    expanded: false,

    active: true,
    subNav: [
      {
        icon: "",
        link: "/permission-management",
        title: "Permission Management",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.PERMISSION_MANAGEMENT],
      },
      {
        icon: "",
        link: "/role-management",
        title: "Role Manangement",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.ROLE_MANAGEMENT],
      },
    ],
  },
  {
    icon: <GroupsOutlinedIcon sx={NAV_ICON_SX} />,
    link: "/society-partner-hub",
    title: "Organization Hub",
    id: "SP",
    role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
    permissions: [PERMISSIONS.ORGANIZATION_HUB],
    expanded: false,

    active: true,
    subNav: [
      // {
      //   icon: "",
      //   link: "/permission-management",
      //   title: "Permission Management",
      //   role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
      //   permissions: [PERMISSIONS.PERMISSION_MANAGEMENT],
      // },
      // {
      //   icon: "",
      //   link: "/role-management",
      //   title: "Role Manangement",
      //   role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
      //   permissions: [PERMISSIONS.ROLE_MANAGEMENT],
      // },
    ],
  },
  {
    icon: <ListAltOutlinedIcon sx={NAV_ICON_SX} />,
    link: "/cpv-listing",
    title: "CPV Listing",
    id: "CPV",
    role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
    permissions: [PERMISSIONS.CPV_LISTING],
    expanded: false,

    active: true,
    subNav: [
      // {
      //   icon: "",
      //   link: "/permission-management",
      //   title: "Permission Management",
      //   role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
      //   permissions: [PERMISSIONS.PERMISSION_MANAGEMENT],
      // },
      // {
      //   icon: "",
      //   link: "/role-management",
      //   title: "Role Manangement",
      //   role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
      //   permissions: [PERMISSIONS.ROLE_MANAGEMENT],
      // },
    ],
  },
  {
    icon: <CreditCardOutlinedIcon sx={NAV_ICON_SX} />,
    link: "/card-management",
    title: "Card Management",
    id: "CAM",
    role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
    permissions: [PERMISSIONS.CARD_MANAGEMENT, PERMISSIONS.ORG_CARD_MANAGEMENT],
    expanded: false,

    active: true,
    subNav: [
      {
        icon: "",
        link: "/card-management",
        title: "Card Product Management",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.CARD_MANAGEMENT],
      },
      {
        icon: "",
        link: "/org-card-management",
        title: "Org Card Product Manangement",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.ORG_CARD_MANAGEMENT],
      },
    ],
  },
  {
    icon: <InventoryIcon sx={NAV_ICON_SX} />,
    link: "/inventory-management",
    title: "Inventory Management",
    id: "IM",
    role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
    permissions: [PERMISSIONS.QR_INVENTORY, PERMISSIONS.SOUNDBOX_INVENTORY, PERMISSIONS.QR_REQUEST],
    expanded: false,

    active: true,
    subNav: [
      {
        icon: "",
        link: "/inventory-management/QR-code-inventory",
        title: "VPA Inventory",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.QR_INVENTORY],
      },
      {
        icon: "",
        link: "/inventory-management/soundbox-inventory",
        title: "Soundbox Inventory",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.SOUNDBOX_INVENTORY],
      },
      {
        icon: "",
        link: "/inventory-management/QR-request",
        title: "QR Request",
        role: ["ROLE_MERCHANT_ADMIN", "ROLE_MERCHANT_SUBADMIN"],
        permissions: [PERMISSIONS.QR_REQUEST],
      },
    ],
  },
];
